import { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import CloseIcon from '@mui/icons-material/Close';

function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [offlineSnackbarOpen, setOfflineSnackbarOpen] = useState(false);
  const [onlineSnackbarOpen, setOnlineSnackbarOpen] = useState(false);
  const [wasOffline, setWasOffline] = useState(false); // Track previous offline state

  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);

      if (navigator.onLine) {
        // Check if it was previously offline, then close the Snackbar
        if (wasOffline) {
          setOfflineSnackbarOpen(false);
        }
        setOnlineSnackbarOpen(true);
        setTimeout(() => {
          setOnlineSnackbarOpen(false);
        }, 3000);
      } else {
        setOfflineSnackbarOpen(true);
      }

      // Update the previous offline state
      setWasOffline(!navigator.onLine);
    };

    window.addEventListener('online', handleStatusChange);
    window.addEventListener('offline', handleStatusChange);

    return () => {
      window.removeEventListener('online', handleStatusChange);
      window.removeEventListener('offline', handleStatusChange);
    };
  }, [wasOffline]);

  const handleRefreshClick = () => {
    window.location.reload();
  };

  return (
    <div>
      <Snackbar
      sx={{marginBottom:{xs:7,md:0,xl:0,lg:0}}}
        open={offlineSnackbarOpen}
        message={
          <div>
            <WifiOffIcon /> You are currently Offline,{' '}
            <Button
              color="primary"
              size="small"
              sx={{ textTransform: 'none' }}
              onClick={handleRefreshClick}
            >
              Refresh?
            </Button>
            <Button
              color="primary"
              size="small"
              onClick={() => setOfflineSnackbarOpen(false)}
            >
              <CloseIcon />
            </Button>
          </div>
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        onClose={() => setOfflineSnackbarOpen(false)} // Close when dismissed
      />

      <Snackbar
      sx={{marginBottom:{xs:7,md:0,xl:0,lg:0}}}
        open={onlineSnackbarOpen}
        message={
          <div>
            <WifiIcon color='success' /> Your Internet connection was restored
          </div>
        }
        autoHideDuration={3000}
        onClose={() => setOnlineSnackbarOpen(false)} // Close when dismissed
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
    </div>
  );
}

export default NetworkStatus;
